<script lang="ts">
	import ArticleCard from "../../../shared/components/ArticleCard.svelte";
	import Layout from "../components/Layout.svelte";
	import { getTranslate } from "../utils/getTranslate.js";
	import translations from "./Blog.translations.json";
	import type { BlogProps } from "./BlogProps.js";

	type $$Props = BlogProps;

	const { news } = $$restProps as $$Props;

	const translate = getTranslate(translations);
</script>

<Layout>
	<div class="container">
		<div class="flex flex-col gap-8 lg:grid lg:grid-cols-2 lg:gap-2 xl:grid-cols-4">
			<div class="order-last flex w-full justify-center p-8 lg:order-first lg:justify-start">
				<h1 class="m-0 p-0 text-center text-xl font-normal lg:text-left lg:text-3xl">{translate("heading")}</h1>
			</div>
			{#each news as article}
				<ArticleCard {article} />
			{/each}
		</div>
	</div>
</Layout>
